import React from "react";
import { ColorInput, Flex, NumberInput, Select } from "@mantine/core";

interface TextStyleInputsProps {
  styles: any;
  setStyles: (styles: any) => void;
  t: (key: string) => string;
}

const TextStyleInputs: React.FC<TextStyleInputsProps> = ({
  styles,
  setStyles,
  t,
}) => {
  return (
    <>
      <Select
        label={t("scheme.redactor.panelOptions.setText.writingMode.title")}
        mb={5}
        value={styles.writingMode || "horizontal-tb"}
        onChange={(value) =>
          setStyles({ ...styles, writingMode: value || "horizontal-tb" })
        }
        data={[
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
          "sideways-rl",
          "sideways-lr",
        ].map((mode) => ({
          value: mode,
          label: t(`scheme.redactor.panelOptions.setText.writingMode.${mode}`),
        }))}
      />

      <ColorInput
        label={t("scheme.redactor.panelOptions.setFigure.polilyne.strokeColor")}
        value={styles.fill}
        onChange={(value) => setStyles({ ...styles, fill: value })}
      />

      <Flex gap={10} align="center">
        <NumberInput
          mb={5}
          label={t("scheme.redactor.panelOptions.setText.fontSize")}
          placeholder={t("scheme.redactor.panelOptions.setText.fontSize")}
          value={styles.fontSize || ""}
          hideControls
          onChange={(value) =>
            setStyles({ ...styles, fontSize: Number(value) })
          }
        />

        <NumberInput
          mb={5}
          label={t("scheme.redactor.panelOptions.setText.rotateText")}
          placeholder={t("scheme.redactor.panelOptions.setText.rotateText")}
          value={
            styles.transform ? Number(styles.transform.match(/-?\d+/)?.[0]) : ""
          }
          hideControls
          onChange={(value) =>
            setStyles({ ...styles, transform: `rotate(${Number(value)})` })
          }
        />
      </Flex>
    </>
  );
};

export default React.memo(TextStyleInputs);
